"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var helpers_1 = require("./helpers");
exports.props = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    return { value: compData.value, targetValue: compData.targetValue };
});
exports.css = withCompInfo_1.withCompInfo(['compProps', 'styleProperties'], function (_a) {
    var compProps = _a.compProps, styleProperties = _a.styleProperties;
    var _b = styleProperties.borderRadius, borderRadius = _b === void 0 ? '0px' : _b, _c = styleProperties.borderSize, borderSize = _c === void 0 ? '0px' : _c;
    return {
        '--direction': compProps.direction,
        '--borderRadius': borderRadius,
        '--borderSize': borderSize,
        '--innerBorderRadius': helpers_1.getInnerBorderRadius(borderRadius, borderSize),
    };
});
//# sourceMappingURL=ProgressBar.js.map